import { Component } from '@angular/core';

import { ButtonModule } from 'primeng/button';

import { BaseConfirmationDialogComponent } from 'sc-common/shared/confirmation/base-confirmation-dialog.component';

@Component({
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
    imports: [ButtonModule]
})
export class ConfirmationDialogComponent extends BaseConfirmationDialogComponent {
}
